(function () {
    let $body = $('body'),
        $window = $(window),
        wspcECommerce = {
            init() {
                $window.load(function () {
                    if ($('#sameAsShipping').length) {
                        wspcECommerce.sameAsShipping();
                    }
                });

                $body.on('click', '[data-bind="submitShipping"]', function () {
                    wspcECommerce.makeSureToLoad();
                });
            },
            makeSureToLoad() {
                if ($('#sameAsShipping').length) {
                    wspcECommerce.sameAsShipping();
                } else {
                    setTimeout(wspcECommerce.makeSureToLoad, 250);
                }
            },
            sameAsShipping() {
                let billingWidgets = literatum.widgets.get('eCommerceCheckoutBillingWidget'),
                    billingWidget = billingWidgets[0];
                /*eslint-disable*/
                billingWidget.widgetDef.binders.sameAsShipping.call(
                    document.getElementById('sameAsShipping'),
                    e,
                    billingWidget
                );
                /*eslint-enable*/
            },
        };
    UX.wspcECommerce = wspcECommerce;
    $(document).ready(UX.wspcECommerce.init);
})();
